import { defineMessages } from 'react-intl'

export default defineMessages({
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  title: {
    id: 'OrganizationSecurityPage.Title',
    defaultMessage: 'Security Settings'
  }
})
